import { useTranslation } from 'next-i18next'

import { useMarket } from './multi-markets/context'

const SelectedCountryLocalized = (): string => {
  const { t } = useTranslation('common')
  const { market } = useMarket()

  return market === 'pl'
    ? t('languageModal.countryPL')
    : market === 'ae'
    ? t('languageModal.countryAE')
    : t('languageModal.countryBH')
}

export default SelectedCountryLocalized
